<script lang="ts" setup>
import { computed } from 'vue'

import { usePageStore } from '@toni/rendering/src/stores/page'
import { BlockContainer } from '@toni/brand-ui'

import { usePageBlockWidth } from '../../../composables/use-page-block-width.ts'
import TeaserGroup from '../../ui/teaser/TeaserGroup.vue'
import { useTeaserGroups } from '../../../components/ui/teaser/use-teaser-groups.ts'

const pageStore = usePageStore()
const adaAutoNative = computed(() => pageStore.pageData?.metaData?.adaAutoNative as boolean)

const props = defineProps<{
    id: string
  }>()

const id = computed(() => props.id)

const { teaserGroupType, teaserGroupVariant, computedTeasers, remainingTeasers } = useTeaserGroups(id.value)

const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)

</script>

<template>
  <BlockContainer
    :size="size"
    :data-ems="adaAutoNative ? 'ems-native-teaserwrapper' : null"
    :flex-container="false"
    :class="[
      'mb-6 md:mb-8',
      teaserGroupType === 'teaser-group-triple' ? 'flex flex-col sm:flex-row sm:gap-5' : '',
      adaAutoNative ? 'grid grid-cols-1 sm:grid-cols-4 gap-5 w-full' : ''
    ]">
    <TeaserGroup :teasers="computedTeasers || []"
                 :variant="adaAutoNative ? 'teaser-group-quadruple' : teaserGroupVariant"
                 :ada-auto-native="adaAutoNative" />
    <TeaserGroup v-if="remainingTeasers.length > 0"
                 :teasers="remainingTeasers"
                 :variant="'teaser-group-triple-other'" />
  </BlockContainer>
</template>
